import { atom } from 'jotai';

export const autoWeightCalculationAtom = atom<boolean>(false);
